"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Textarea = void 0;

var React = _interopRequireWildcard(require("react"));

var _FormFieldWrapper = _interopRequireDefault(require("../FormFieldWrapper/FormFieldWrapper"));

var _FieldLabel = _interopRequireDefault(require("../../ui/FieldLabel"));

var _textareaConfig = require("./textareaConfig");

var _types = require("../../types");

var _validation = require("../../types/validation");

var _flowRuntime = _interopRequireDefault(require("flow-runtime"));

var InheritedFieldValidation = _flowRuntime["default"].tdz(function () {
  return _validation.InheritedFieldValidation;
});

var InputStyle = _flowRuntime["default"].tdz(function () {
  return _types.InputStyle;
});

var TextareaDefinition = _flowRuntime["default"].tdz(function () {
  return _textareaConfig.TextareaDefinition;
});

var Props = _flowRuntime["default"].type("Props", _flowRuntime["default"].object(_flowRuntime["default"].property("disabled", _flowRuntime["default"]["boolean"](), true), _flowRuntime["default"].property("inheritedFieldValidation", _flowRuntime["default"].array(_flowRuntime["default"].ref(InheritedFieldValidation)), true), _flowRuntime["default"].property("noOptionalLabel", _flowRuntime["default"]["boolean"](), true), _flowRuntime["default"].property("textarea", _flowRuntime["default"].ref(TextareaDefinition))));

var TextareaProps = _flowRuntime["default"].type("TextareaProps", _flowRuntime["default"].object(_flowRuntime["default"].property("disabled", _flowRuntime["default"]["boolean"](), true), _flowRuntime["default"].property("input", _flowRuntime["default"].object()), _flowRuntime["default"].property("inputStyle", _flowRuntime["default"].ref(InputStyle)), _flowRuntime["default"].property("isRequired", _flowRuntime["default"]["boolean"]()), _flowRuntime["default"].property("textarea", _flowRuntime["default"].ref(TextareaDefinition))));

var Textarea = function Textarea(_arg) {
  var disabled = _arg.disabled,
      input = _arg.input,
      isRequired = _arg.isRequired,
      inputStyle = _arg.inputStyle,
      textarea = _arg.textarea;
  var inputValue = input.value || '';
  var charactersRemaining = textarea.maxLength && textarea.maxLength - inputValue.length;
  var characterString = charactersRemaining === 1 ? 'character' : 'characters';
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("label", {
    htmlFor: input.name
  }, /*#__PURE__*/React.createElement(_FieldLabel["default"], {
    field: textarea,
    isRequired: isRequired
  }), /*#__PURE__*/React.createElement("textarea", Object.assign({
    autoComplete: textarea.autoComplete,
    className: inputStyle.inputClass,
    disabled: disabled,
    id: input.name,
    maxLength: textarea.maxLength,
    placeholder: textarea.placeholder && "".concat(textarea.placeholder).concat(!isRequired ? ' (optional)' : ''),
    rows: textarea.rows
  }, input))), textarea.maxLength && /*#__PURE__*/React.createElement("small", {
    style: {
      display: 'block',
      marginTop: '-10px'
    }
  }, charactersRemaining, " ", characterString, " remaining"));
};

exports.Textarea = Textarea;
Textarea.defaultProps = {
  disabled: false
};

var RFTextarea = function RFTextarea(_arg2) {
  var disabled = _arg2.disabled,
      inheritedFieldValidation = _arg2.inheritedFieldValidation,
      textarea = _arg2.textarea,
      noOptionalLabel = _arg2.noOptionalLabel;
  return /*#__PURE__*/React.createElement(_FormFieldWrapper["default"], {
    field: textarea,
    renderField: function renderField(_ref) {
      var input = _ref.input,
          inputStyle = _ref.inputStyle,
          isRequired = _ref.isRequired;
      return /*#__PURE__*/React.createElement(Textarea, {
        disabled: disabled,
        input: input,
        inputStyle: inputStyle,
        isRequired: noOptionalLabel ? true : isRequired,
        textarea: textarea
      });
    },
    inheritedFieldValidation: inheritedFieldValidation
  });
};

RFTextarea.defaultProps = {
  disabled: false,
  inheritedFieldValidation: [],
  noOptionalLabel: false
};
var _default = RFTextarea;
exports["default"] = _default;